export const initialColumnVisibility = {
  is_employed: false,
  is_student: false,
  citizenship: false,
  student_id_valid_until: false,
  bank_account_number: false,
};
